module.exports = __webpack_public_path__ + "static/media/cc.58b6871d.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/myaccount/Dashboard/cc.svg
 ** module id = 1326
 ** module chunks = 0
 **/